module.exports = "<select class=\"form-control\" [disabled]=\"isLoadingItems || isDisabled\" [(ngModel)]=\"selectedItem\">\r\n    <option *ngIf=\"isLoadingItems\" [ngValue]=\"nullValue\">Loading...</option>\r\n    <option *ngIf=\"isDisabled\" [ngValue]=\"nullValue\"></option>\r\n    <option *ngIf=\"!isLoadingItems && selectedItem == nullValue\" [ngValue]=\"nullValue\">Please select...</option>\r\n    <option *ngFor=\"let item of items\" [ngValue]=\"item\">\r\n        {{item.name}}\r\n    </option>\r\n</select>\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/components/dropdown.template.html
// module id = 33
// module chunks = 10